<template>
    <div>
        <div class="text-center" v-show="accounts.length == 0">
            <label class="header-label-lg">{{ searchMessage }}</label>
        </div>
        <account-list-item 
            v-for="(account, index) in accounts" 
            :account_nbr="account.account_nbr"
            :account_nm="account.account_nm" 
            :city="account.city" 
            :state_cd="account.state_cd"
            :role_label="account.role_label" 
            :is_default="account.is_default"
            :is_selected="selectedAccountNumbers.indexOf(account.account_nbr) != -1"
            :is_credit_hold="!!account.is_credit_and_collection" 
            :index="index" 
            @select="selectAccount"
            @remove="removeAccount" 
            @default="setDefaultAccount"
        ></account-list-item>
    </div>
</template>

<style></style>

<script>
export default {
    props: {
        filter: { default: '' },
        roles: { default: function () { return []; } },
        services: { default: function () { return []; } },
        delay: { default: false },
        multiple: { default: function () { return this.$parent.multiple; } },
        selectedAccounts: { default: function () { return []; } },
        selectedAccountNumbers: { default: function () { return []; } },
        should_cc_hold: { default: false }
    },

    data: function () {
        return {
            accounts: [],
            accountSearchTimerId: 0,
        }
    },

    watch: {
        filter: function () {
            this.queueAccountSearch();
        }
    },

    computed: {
        searchMessage: function () {
            if (this.accounts.length == 0 && this.filter) {
                if (this.filter.length < 3) return 'Enter at least 3 characters to search.'
                else return 'No Accounts Found';
            }
            else {
                return 'Enter an account number or name above to search.';
            }
        }
    },

    methods: {
        getAccounts: function (success) {
            this.$http.get('/user/accounts', {
                params: {
                    filter: this.filter,
                    roles: this.roles,
                    services: this.services,
                    should_cc_hold: this.should_cc_hold ? 1 : 0
                }
            }).then(function (response) {
                this.accounts.splice(0, this.accounts.length);
                if (this.multiple) {
                    this.accounts = this.selectedAccounts.slice(0);
                }
                if (response.data) {
                    for (var i = 0; i < response.data.length; i++) {
                        var account = response.data[i];
                        if (this.accounts.map(function (a) { return a.account_nbr }).indexOf(account.account_nbr) == -1) {
                            this.accounts.push(account);
                        }
                    }
                }
                this.$emit('update', this.accounts);
                if (typeof success === 'function') success(response);
            });
        },

        queueAccountSearch: function () {
            var vm = this;
            if (this.accountSearchTimerId) clearTimeout(this.accountSearchTimerId);
            this.accountSearchTimerId = setTimeout(function () {
                vm.getAccounts();
            }, 250);
        },

        selectAccount: function (accountIndex) {
            var account = this.accounts[accountIndex];
            this.$emit('select', account.account_nbr);
        },


        removeAccount: function (accountIndex) {
            var account = this.accounts[accountIndex];
            this.$emit('remove', account.account_nbr);
        },

        setDefaultAccount: function (accountIndex) {
            var account = this.accounts[accountIndex];
            var request = this.$http.post('/user/set-default-account', { account_nbr: account.account_nbr });
            request.then(function (response) {
                if (response.data && response.data.status) {
                    for (var i = 0; i < this.accounts.length; i++) {
                        if (this.accounts[i].account_nbr == account.account_nbr) {
                            this.accounts[i].is_default = true;
                            this.selectAccount(accountIndex);
                        }
                        else {
                            this.accounts[i].is_default = false;
                        }
                    }
                }
            });
        }
    },

    mounted: function () {
        if (!this.delay) this.getAccounts();
    }
}
</script>



// WEBPACK FOOTER //
// account-list.vue?09202dde